import { Component, Injector } from '@angular/core';

import { ApAlertService } from '../ap-alert/index';
import { ApComplexModal } from 'webcommon/core-ui/modals-ng1520';

@Component({
  selector: 'ap-file-upload-import-modal',
  templateUrl: './ap-file-upload-modal.component.html',
  providers: [
    ApAlertService,
  ],
})
export class ApFileUploadModalComponent extends ApComplexModal<File> {
  allowedExtensions?: string;
  message?: string;
  title?: string;

  selectedFile?: File;

  constructor(
    elementInjector: Injector,
    private readonly apAlertService: ApAlertService,
  ) {
    super(elementInjector);
  }

  displayError(event: string) {
    this.apAlertService.clearAllErrorAlerts();

    if (event) {
      this.apAlertService.error(event);
    }
  }

  filesChanged(files: File[]) {
    this.selectedFile = files[0];
  }

  cancel() {
    this.apUserCancel();
  }

  close() {
    if (this.selectedFile) {
      this.apClose(this.selectedFile);
    }
  }
}
